import {v4} from 'uuid';
const logger = require('@azure/logger');
logger.setLogLevel('verbose');

const sessionGuid = v4();

export const sessionIdentifier = sessionGuid;